<template>
    <div :class="$style['year-month-select']">
        <el-button :class="$style['date-icon']" type="text" icon="el-icon-d-arrow-left" @click="prevYear"></el-button>
        <el-button :class="$style['date-icon']" type="text" icon="el-icon-arrow-left" @click="prevMoth"></el-button>
        <span v-html="dateHtml"></span>
        <el-button :class="$style['date-icon']" type="text" icon="el-icon-arrow-right" @click="nextMonth"></el-button>
        <el-button :class="$style['date-icon']" type="text" icon="el-icon-d-arrow-right" @click="nextYear"></el-button>

    </div>
</template>

<script>
export default {
  computed: {
    dateHtml () {
      return `${this.currentYear}年${this.currentMonth}月`
    }
  },
  props: {
    value: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      currentYear: this.value ? this.value.year : new Date().getFullYear(),
      currentMonth: this.value ? this.value.month : new Date().getMonth() + 1
    }
  },
  watch: {
    value (val, old) {
      if (val !== old) {
        this.currentYear = val && val.year ? val.year : new Date().getFullYear()
        this.currentMonth = val && val.month ? val.month : new Date().getMonth() + 1
      }
    },
    currentMonth (val) {
      if (val < 1) {
        this.currentMonth = 12
        this.currentYear -= 1
      }
      if (val > 12) {
        this.currentMonth = 1
        this.currentYear += 1
      }
      this.emitDae()
    },
    currentYear (val) {
      if (val < 100) {
        this.currentYear = new Date().getFullYear()
      }
      this.emitDae()
    }
  },
  methods: {
    emitDae () {
      this.$emit('input', { year: this.currentYear, month: this.currentMonth })
    },
    prevYear () {
      this.currentYear -= 1
    },
    prevMoth () {
      this.currentMonth -= 1
    },
    nextMonth () {
      this.currentMonth += 1
    },
    nextYear () {
      this.currentYear += 1
    }
  }
}
</script>

<style lang="less" module>
.year-month-select{
    display: flex;
    max-width: 300px;
    justify-content: space-between;
    justify-items: center;
    margin:0 auto;
    .date-icon{
        font-size: 20px;
    }
    > span{
        line-height:46px;
        font-size: 20px;
    }
}

</style>
